import { $toast } from "vuetify-snackbar-toast";

export default function $handleError(error) {
  const message = error?.message || error?.error?.message;
  if (!message?.includes("Unauthenticated")) {
    if (message) {
      $toast.danger(message);
      return;
    }
    $toast.danger(error);
  }
}

export const handleErrorPlugin = (vue) => {
  vue.prototype.$handleError = $handleError;
};
